<template>
  <div>
    <div :style="{ height: '1px', 'margin-bottom': '1px' }" ref="initiator">&nbsp;</div>
    <div :style="{ height: '1px' }">&nbsp;</div>
  </div>
</template>

<script type="application/javascript">
/*
 * This bottom-of-the-page-in-view detector uses an interval rather than scroll-based logic. For
 * some reason the scroll-event-based logic would randomly fail because the scroll event was no
 * longer fired. I could not figure out why this was occurring, but even using a third-party library
 * that should do this out of the box ran into the same issue. So I decided to implement one that
 * uses a much different strategy: Check if our element is visible every 250 milliseconds.
 */
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false,
      }
    },

    data() {
      return {
        intervalReference: null
      };
    },

    mounted() {
      const vm = this;
      this.intervalReference = setInterval(function(e) {
        if (vm.handleBottomReachedCheck) vm.handleBottomReachedCheck();
      }, 250);
    },
    unmounted() {
      clearInterval(this.intervalReference);
    },
    destroyed() {
      clearInterval(this.intervalReference);
    },
    methods: {
      handleBottomReachedCheck: function() {
        // Quit if we're not wanted right now
        if (this.disabled) return;

        const initiator = this.$refs.initiator;
        // If not there for some reason we quit
        if (!initiator) return;

        const { top, bottom } = initiator.getBoundingClientRect();
        // If height is 0 then it's not displayed so we quit
        if (top-bottom === 0) return;

        // console.info(top, bottom, window.innerHeight)
        if (bottom < window.innerHeight) {
          this.$emit('bottomReached');
        }
      }
    }
  }
</script>